import * as types from './mutation-types';

export default {
    [types.SET_BREADCRUMB](state, payload) {
        state.breadcrumb = payload
    }
}